// Modules
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'mobx-react';
import 'normalize.css';
import 'animate.css';

// Stores
import AuthStore from './stores/AuthStore';
import PinStore from './stores/PinStore';

// Components
import App from './components/App';

// Styles
import './index.css';

const Root = () => (
  <Provider
    AuthStore={AuthStore}
    PinStore={PinStore}
  >
    <App />
  </Provider>
);

ReactDOM.render(<Root />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js